import { render } from "./ConhecimentoPublicacoes.vue?vue&type=template&id=67b6b4b6"
import script from "./ConhecimentoPublicacoes.vue?vue&type=script&lang=js"
export * from "./ConhecimentoPublicacoes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__